<template>
  <div class="cp-pagination">
    <button
      :class="['prev', 'iconfont',internalCurrentPage === 1 ? 'nomorePage' : '']"
      @click="changePage('prev')"
      v-if="setting.prev"
    >&#xe602;</button>
    <ul>
      <li :class="[internalCurrentPage === 1 ? 'activ-page' : '']" @click="changePage(1)">1</li>
      <li v-if="pagers.showPrevMore" @click="changeMore('prev')">…</li>
      <li
        :class="[internalCurrentPage === item ? 'activ-page' : '']"
        v-for="item in pagers.pagers"
        @click="changePage(item)"
        :key="item"
      >{{item}}</li>
      <li v-if="pagers.showNextMore" @click="changeMore('next')">…</li>
      <li
        :class="[internalCurrentPage === pagers.lastPage ? 'activ-page' : '']"
        v-if="pagers.lastPage"
        @click="changePage(pagers.lastPage)"
      >{{pagers.lastPage}}</li>
    </ul>
    <button
      :class="['next', 'iconfont',internalCurrentPage === pagers.lastPage? 'nomorePage' : '']"
      @click="changePage('next')"
      v-if="setting.next"
    >&#xe66a;</button>
    <div v-if="setting.jumper" class="jumper-box">
      <span>跳转到</span>
      <input
        type="number"
        name="currentPage"
        id
        @change="inputChange"
        v-model.number="internalCurrentPage"
        min="1"
        :max="re_pageSize"
      >
      <span>页</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["currentPage", "total", "limit", "layout", "goTop"],
  data() {
    return {
      internalCurrentPage: 1,
      lastEmittedPage: -1,
      setting: {
        prev: false,
        next: false,
        jumper: false
      },
      needGoTop: false
    };
  },
  methods: {
    inputChange(v) {
      let pageNumber =
        v.srcElement.valueAsNumber > this.re_pageSize
          ? this.re_pageSize
          : v.srcElement.valueAsNumber;
      this.internalCurrentPage = pageNumber;
      this.theEmit();
    },
    changeMore(type) {
      switch (type) {
        case "prev":
          this.changePage(this.pagers.pagers[0] - 1);
          break;
        case "next":
          this.changePage(
            this.pagers.pagers[this.pagers.pagers.length - 1] + 1
          );
          break;
        default:
      }
    },
    changePage(type) {
      switch (type) {
        case "prev":
          if (this.internalCurrentPage === 1) return;
          this.internalCurrentPage -= 1;
          break;
        case "next":
          if (this.internalCurrentPage === this.re_pageSize) return;
          this.internalCurrentPage += 1;
          break;
        default:
          this.internalCurrentPage = parseInt(type);
      }
      this.theEmit();
    },
    theEmit() {
      this.lastEmittedPage = this.internalCurrentPage;
      this.$emit("current-change", this.internalCurrentPage);
      if (this.needGoTop) {
        document.querySelector("body").scrollIntoView();
      }
    }
  },
  created() {
    let settinglist = ["prev", "next", "jumper"];
    this.needGoTop = this.goTop ? true : false;
    if (this.layout) {
      settinglist.forEach(item => {
        if (this.layout.indexOf(item) > -1) {
          this.setting[item] = true;
        } else {
          this.setting[item] = false;
        }
      });
    }
  },
  watch: {
    currentPage() {
      this.internalCurrentPage = this.currentPage;
    }
  },
  computed: {
    re_pageSize() {
      return Math.ceil(this.total / this.limit);
    },
    pagers() {
      let pageInfo = {
        firstPage: 1,
        showPrevMore: false,
        pagers: [2, 3, 4, 5],
        showNextMore: false,
        lastPage: null
      };
      let re_pageSize = this.re_pageSize;
      let currentPage = this.currentPage;
      let pagers = [];
      if (re_pageSize < 7) {
        pageInfo.pagers = [];
        for (let i = 2; i < re_pageSize + 1; i++) {
          pageInfo.pagers.push(i);
        }
      } else if (re_pageSize === 7) {
        pageInfo.pagers = [];
        for (let i = 2; i < re_pageSize; i++) {
          pageInfo.pagers.push(i);
        }
        pageInfo.lastPage = re_pageSize;
      } else if (re_pageSize > 7) {
        if (currentPage < 5) {
          pageInfo.pagers = [2, 3, 4, 5, 6];
          pageInfo.showNextMore = true;
          pageInfo.lastPage = re_pageSize;
        } else if (currentPage > re_pageSize - 4) {
          pageInfo.pagers = [];
          for (let i = re_pageSize - 5; i < re_pageSize; i++) {
            pageInfo.pagers.push(i);
          }
          pageInfo.lastPage = re_pageSize;
          pageInfo.showPrevMore = true;
        } else {
          pageInfo.pagers = [];
          for (let i = currentPage - 2; i < currentPage + 3; i++) {
            pageInfo.pagers.push(i);
          }
          pageInfo.lastPage = re_pageSize;
          pageInfo.showPrevMore = true;
          pageInfo.showNextMore = true;
        }
      }
      return pageInfo;
    }
  }
};
</script>

<style lang="less" scoped>
.cp-pagination {
  padding: 10px;
  width: 100%;
  justify-content: center;
  display: flex;
  align-items: center;

  button {
    margin-right: 10px;
    cursor: pointer;
  }

  .nomorePage {
    cursor: not-allowed;
  }

  .jumper-box {
    margin-left: 40px;

    input {
      height: 36px;
      border-radius: 4px;
      border: 1px solid #e8e8e8;
      outline: none;
      min-width: 55px;
      box-sizing: border-box;
      padding-left: 10px;
      max-width: 64px;
    }
  }

  ul {
    display: flex;
    align-items: center;

    li {
      cursor: pointer;
      min-width: 36px;
      height: 36px;
      line-height: 36px;
      // border: 1px solid #ccc;
      background-color: #f6f6f6;
      padding: 0 9px;
      text-align: center;
      border-radius: 4px;
      margin-right: 10px;
    }

    .activ-page {
      background-color: #3278d2;
      color: #fff;
    }
  }
}
</style>
